import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Link as ChakraLink, List, ListItem } from '@chakra-ui/react';
import { businessListStyles, linkStyles, listItemStyles, listStyles } from '../NavigationMenu.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function AuthSubNav(_ref) {
  var labels = _ref.labels,
    onLogout = _ref.onLogout;
  var accountLinks = labels === null || labels === void 0 ? void 0 : labels.accountLinks;
  return _jsx(Flex, _objectSpread(_objectSpread({}, businessListStyles), {}, {
    children: _jsxs(List, _objectSpread(_objectSpread({}, listStyles), {}, {
      children: [accountLinks === null || accountLinks === void 0 ? void 0 : accountLinks.map(accountLink => _createElement(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
        "data-testid": "listItem",
        key: accountLink.title
      }), _jsx(ChakraLink, _objectSpread(_objectSpread({
        href: accountLink.url
      }, linkStyles), {}, {
        "data-testid": "".concat(accountLink.title, "Button"),
        children: accountLink.title
      })))), _jsx(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
        "data-testid": "listItem",
        children: _jsx(ChakraLink, _objectSpread(_objectSpread({}, linkStyles), {}, {
          onClick: onLogout,
          "data-testid": "Global-Logout-Desktop",
          children: labels.logOut
        }))
      }))]
    }))
  }));
}